import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ProvidersServices } from "../../../providers/services";
import { StockProviderListPage } from "../../../stock/stock-provider-list/stock-provider-list";
import { StaticsServices } from '../../../services/statics';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ProviderOrderAddPage } from '../../orders/provider-order-add/provider-order-add';
import { IngredientViewPage } from '../../../ingredients/ingredient-view/ingredient-view/ingredient-view';
import { ProvidersAddSelectElementsPage } from '../../providers-add-select-elements/providers-add-select-elements';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ArticleViewPage } from '../../../articles/articles-view/article-view';
import { DeliberyNoteViewPage } from '../../../delibery_note/delibery-note-view/delibery-note-view/delibery-note-view';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';


/**
 * Generated class for the ProvidersCreateDataPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-providers-create-data.html',
  templateUrl: 'providers-create-data.html',
})
export class ProvidersCreateDataPage {
  public form: FormGroup;
  provider_uid: any;
  update_state: boolean = false;
  base: any;
  tax: any;
  total: any;
  provider_name: any;
  ingredients: any;
  products: any;
  element_type: any = 'ingredient';
  _observations: string = '';
  observations: string = '';

  license_access: boolean = true;
  num_providers: any;

  //
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public staticsServices: StaticsServices,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public translate: TranslateService,) {
    this.globals.GAtrackView('Providers', 'Providers - View', this.globals.restaurant.email, 'View', 'View provider', 'Providers', '');


    //Params
    this.update_state = this.navParams.get('update_state');
    this.provider_uid = this.navParams.get('provider_uid');
    this.provider_name = this.navParams.get('name');

    //d
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //get ings provider

    //get prods provider
    loadingPopup.dismiss();


    this.form = fb.group({
      name: [this.navParams.get('name'), Validators.compose([Validators.required])],
      contact_name: [this.navParams.get('contact_name')],
      nif: [this.navParams.get('nif')],
      email: [this.navParams.get('email'), Validators.compose([Validators.required])],
      phone: [this.navParams.get('phone')],
      address: [this.navParams.get('address')],
      fixed_phone: [this.navParams.get('fixed_phone')],
      web: [this.navParams.get('web')],
      no_provider: [this.navParams.get('no_provider')],
      _observations: [this.navParams.get('observations')],
    });
  }



  // funcion para añadir 0 si es menos de 10 el el dia y el mes
  padStart(str: string, targetLength: number, padString: string): string {
    if (str.length >= targetLength) {
      return str;
    } else {
      targetLength = targetLength - str.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + str;
    }
  }

  async ionViewWillEnter() {

    this.providersServices.providers_ingredients_array = [];
    this.providersServices.providers_products_array = [];
    this.providersServices.delivery_notes_array = [];

    this.providersServices.page_active = 1;
    // 0 => sin límite, cargar todos los ingredientes del proveedor
    await this.providersServices.getPagesIngredientsProvider(0, this.provider_uid);
    // 0 => sin límite, cargar todos los productos del proveedor
    await this.providersServices.getPagesProductsProvider(0, this.provider_uid)
    await this.providersServices.get_provider_delivery_notes(this.globals.restaurant_uid, this.provider_uid)



    let limit = this.globals.checkLimitsByLicense('stock', 'providers')
    //Miramos el limite de proveedores
    if (limit >= 0) {

      //si tiene limite recuperamos el numero de proveedores y lo comparamos con el limite
      const params = new HttpParams()
        .set('uid', this.globals.restaurant_uid)
        .set('elements_per_page', limit + 30)
        .set('limit', limit);
      await this.http.post(this.globals.analytics_path + 'paginate/limited_provider', params, {})
        .subscribe(async res => {
          //si el limite se supera, no puede crear mas proveedores

          this.num_providers = res['list_providers'].length;
          if (res['list_providers'].length > limit) {
            this.license_access = false;
          }
        });
    }
  }


  // busqeuda de texto
  SearchBar(event) {
    var searchText = event.target.value.toLowerCase();

    if (searchText.length <= 1) {
      // Restablece a los estados originales si el texto de búsqueda es muy corto
      this.providersServices.providers_ingredients_array = [...this.providersServices.providers_ingredients_array_tmp];
      this.providersServices.providers_products_array = [...this.providersServices.providers_products_array_tmp];
      this.providersServices.delivery_notes_array = [...this.providersServices.delivery_notes_array_tmp];
    } else {
      // Procede con el filtrado solo si hay suficiente texto con el cual buscar
      if (this.element_type === 'ingredient') {
        this.providersServices.providers_ingredients_array = this.providersServices.providers_ingredients_array_tmp.filter(item => item.name.toLowerCase().includes(searchText));
      }
      else if (this.element_type === 'product') {
        this.providersServices.providers_products_array = this.providersServices.providers_products_array_tmp.filter(item => item.name.toLowerCase().includes(searchText));
      }
      else if (this.element_type === 'delivery-note') { // Corregido typo 'delibery-note' a 'delivery-note'
        this.providersServices.delivery_notes_array = this.providersServices.delivery_notes_array_tmp.filter(item => item.number.toLowerCase().includes(searchText));
      }
    }
  }


  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-anade-nombre-email-proveedor-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {
    this.providersServices.afs.collection('providers').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.form.value.name,
      'contact_name': this.form.value.contact_name,
      'nif': this.form.value.nif,
      'email': this.form.value.email,
      'phone': this.form.value.phone,
      'address': this.form.value.address,
      'fixed_phone': this.form.value.fixed_phone,
      'web': this.form.value.web,
      'no_provider': this.form.value.no_provider,
      'observations': this.form.value._observations,
      'created_at': new Date(),
      'updated_at': new Date(),

    }).then(async doc => {
      this.globals.GAtrackView('Providers', 'Providers - Create', this.globals.restaurant.email, 'Create/Update', 'Create provider', 'Providers', this.form.value.name);
      //enviar a cloud functions _emails
      this.providersServices.afs.collection('_emails').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'type': 'welcome_provider',
        'company': this.globals.restaurant.company,
        'provider_name': this.form.value.name,
        'provider_email': this.form.value.email,
        'restaurant_lang': this.globals.restaurant.lang
      });
      //
      if (this.providersServices.quick_create) {
        this.providersServices.quick_create = false;
        this.navCtrl.pop();
      } else {
        this.navCtrl.setRoot(StockProviderListPage, {
          //update: false,
          //delibery_note_uid: doc.id,
        });
      }

    });
  }

  update() {
    this.providersServices.afs.collection('providers').doc(this.provider_uid).update({
      'name': this.form.value.name,
      'contact_name': this.form.value.contact_name,
      'nif': this.form.value.nif,
      'email': this.form.value.email,
      'phone': this.form.value.phone,
      'address': this.form.value.address,
      'fixed_phone': this.form.value.fixed_phone,
      'web': this.form.value.web,
      'no_provider': this.form.value.no_provider,
      'observations': this.form.value._observations,
      'updated_at': new Date(),
    }).then(() => {
      this.globals.GAtrackView('Providers', 'Providers - Update', this.globals.restaurant.email, 'Create/Update', 'Update provider', 'Providers', this.form.value.name);
      this.staticsServices.changeStateStaticWait(true);
      this.navCtrl.pop();
    });
  }

  public handleAddressChange(address) {
    this.form.value.address = address.formatted_address;
  }

  delete() {

    let alert = this.alertCtrl.create({

      title: this.translate.instant('instant-eliminar-proveedor'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Providers', 'Providers - Delete', this.globals.restaurant.email, 'Delete', 'Delete provider', 'Providers', this.form.value.name);
            //
            if (this.providersServices.filteredProvidersActive) {
              this.providersServices.filteredProviders.splice(this.providersServices.filteredProviders.findIndex(item => item.UID == this.provider_uid), 1);
            }
            //
            this.providersServices.delete(this.provider_uid);
            this.startDeleteStatics();
            //Falta static que coloca el producto en sin proveedor.
            this.redirect();
          }
        }
      ]
    });
    alert.present();
  }
  async redirect() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    await this.globals.delay(1000);
    this.navCtrl.pop();
    loadingPopup.dismiss();
  }

  async startDeleteStatics() {
    this.staticsServices.changeStateStaticWait(true);
    this.staticsServices.addDeleteStaticToQueue(this.provider_uid, 'delete_provider_update');
  }

  openProviderOrderAdd(element, type) {
    this.navCtrl.push(ProviderOrderAddPage, {
      element: element,
      type: type
    });
  }

  openIngredientView(ingredient) {
    if (ingredient._active) {
      this.navCtrl.push(IngredientViewPage, {

        ingredient_uid: ingredient.UID

      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }

  }

  openProductView(product) {
    if (product._active || -1 == this.globals.checkLimitsByLicense('stock', 'ings_prods')) {
      this.navCtrl.push(ArticleViewPage, {
        article_type: 'product',
        article_uid: product.UID
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openSetProviderIngredients() {
    this.navCtrl.push(ProvidersAddSelectElementsPage, {
      type: 'ingredients',
      provider_uid: this.provider_uid,
      provider_name: this.provider_name
    });
  }

  openSetProviderProducts() {

    this.navCtrl.push(ProvidersAddSelectElementsPage, {
      type: 'products',
      provider_uid: this.provider_uid,
      provider_name: this.provider_name
    });
  }

  viewDeliveryNote(uid) {

    this.navCtrl.push(DeliberyNoteViewPage, {
      update_state: true,
      delibery_note_uid: uid
    });
  }


  // cambiamos el tipo de elemento si se cambia el tab-pane de la pagina para poder filtarar mas tarde con serachbar
  changeType(type) {
    this.element_type = type;
    this.providersServices.page_active = 1;
  }



  searchElementsProvidersNode(value) {
    this.providersServices.searchElementsProvidersNode(value, this.provider_uid, this.element_type);
  }

  nextPage() {
    if (this.element_type == 'ingredient') {
      if (this.providersServices.page_active < this.providersServices.pagesIngredients.length) {
        this.providersServices.page_active += 1
      }
      this.providersServices.getListIngredientsProviders();
    } else {
      if (this.providersServices.page_active < this.providersServices.pagesProducts.length) {
        this.providersServices.page_active += 1
      }
      this.providersServices.getListProductsProviders();
    }

  }
  previusPage() {
    if (this.providersServices.page_active > 1) {
      this.providersServices.page_active -= 1;
    }
    if (this.element_type == 'ingredient') {
      this.providersServices.getListIngredientsProviders();
    } else {
      this.providersServices.getListProductsProviders();
    }
  }
  activePage(number) {
    this.providersServices.page_active = number;
    if (this.element_type == 'ingredient') {
      this.providersServices.getListIngredientsProviders();
    } else {
      this.providersServices.getListProductsProviders();
    }
  }

  public getInitObservations(editor: any) {
    if (editor.html) {
      this.observations = editor.html;
    }
  }

  alignByDimensions() {
    if (this.globals.platform_width === 'mobile' || this.globals.platform_width === 'tablet') {
      let cssClasses = {
        'text-left': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'text-right': true,
      }
      return cssClasses;
    }
  }

  marginByDimensions() {
    if (this.globals.platform_width === 'mobile' || this.globals.platform_width === 'tablet') {
      let cssClasses = {
        'margin-bot': false,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'margin-bot': true,
      }
      return cssClasses;
    }
  }

  clickElement(event) {
    if (event.type == 'click') {
      if (event.column.name != 'add_order') {
        if (this.element_type === 'ingredient') {
          this.openIngredientView(event.row);
        } else if (this.element_type === 'product') {
          this.openProductView(event.row);
        } else {
          this.viewDeliveryNote(event.row.UID);
        }
      } else if (event.column.name === 'add_order') {
        if (this.element_type === 'ingredient') {
          this.openProviderOrderAdd(event.row, event.row.type);
        } else if (this.element_type === 'product') {
          this.openProviderOrderAdd(event.row, event.row.type);
        }
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/providers/providers-create/providers-create-data/providers-create-data.ts